module.exports = __webpack_public_path__ + "img/maddox.fc0a2039.jpg";